export default __webpack_public_path__ + "images/close-icon-blue.svg";